import api from './api';

export interface Team {
  id: number;
  name: string;
  contact_number?: string;
  email?: string;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  agents_count?: number;
  customers_count?: number;
}

export interface CreateTeamData {
  name: string;
  contact_number?: string;
  email?: string;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const teamService = {
  async getAll() {
    const response = await api.get('/teams');
    return response.data;
  },

  async create(data: CreateTeamData): Promise<Team> {
    const response = await api.post('/teams', data);
    return unwrap<Team>(response);
  },

  async update(id: number, data: Partial<CreateTeamData>): Promise<Team> {
    const response = await api.put(`/teams/${id}`, data);
    return unwrap<Team>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/teams/${id}`);
  },
};

